import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { SuperadminModule } from './components/superadmin/superadmin.module';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { CreateStatementDialogComponent } from './create-statement-dialog/create-statement-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CreateGroupDialogComponent } from './create-group-dialog/create-group-dialog.component';
import { CreateLedgerDialogComponent } from './create-ledger-dialog/create-ledger-dialog.component';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CreateVoucherPostingDialogComponent } from './create-voucher-posting-dialog/create-voucher-posting-dialog.component';
import { CreateVoucherDialogComponent } from './create-voucher-dialog/create-voucher-dialog.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCard, MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { CreateBranchDialogComponent } from './create-branch-dialog/create-branch-dialog.component';
import { ImportStatementViewComponent } from './import-statement-view/import-statement-view.component';
import { LoginComponent } from './login/login.component';
import { AuthInterceptor } from './auth.interceptor';
import { ErrorInterceptor } from './error.interceptor';
import { LogInterceptor } from './log.interceptor';
import { FileShowModalComponent } from './file-show-modal/file-show-modal.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SuperadminLayoutComponent } from './layouts/superadmin-layout/superadmin-layout.component';
import { UserRegistrationComponent } from './superadmin/user-registration/user-registration.component';
import { CreateVoucherPostingViewComponent } from './create-voucher-posting-view/create-voucher-posting-view.component';
import { CreateVoucherPostingPreviewComponent } from './create-voucher-posting-preview/create-voucher-posting-preview.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ApprovalPathMasterComponent } from './approval-path-master/approval-path-master.component';
import { ApprovalPathMappingComponent } from './approval-path-mapping/approval-path-mapping.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NotfoundComponent } from './notfound/notfound.component';
// import { CreateVendorMasterComponent } from './create-vendor-master/create-vendor-master.component';
import { CreateCategoryMasterComponent } from './create-category-master/create-category-master.component';
import { CreateItemMasterComponent } from './create-item-master/create-item-master.component';
import { CreateUnitMasterComponent } from './create-unit-master/create-unit-master.component';
import { CreateGstMasterComponent } from './create-gst-master/create-gst-master.component';
import { LoginDashboardComponent } from './login-dashboard/login-dashboard.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UserListComponent } from './user-list/user-list.component';
import { CreatServiceMasterDialogComponent } from './creat-service-master-dialog/creat-service-master-dialog.component';
// import { CreateProductViewDialogComponent } from './create-product-view-dialog/create-product-view-dialog.component';
// import { CreateProductEditDialogComponent } from './create-product-edit-dialog/create-product-edit-dialog.component';
import { CreateCustomerMasterDialogComponent } from './create-customer-master-dialog/create-customer-master-dialog.component';
import { CreateInvoicePaymentDialogComponent } from './create-invoice-payment-dialog/create-invoice-payment-dialog.component';
import { CreateBranchMasterDialogComponent } from './create-branch-master-dialog/create-branch-master-dialog.component';
import { CreateBranchDetailsComponent } from './create-branch-details/create-branch-details.component';
import { CreateVendorMasterDialogComponent } from './create-vendor-master-dialog/create-vendor-master-dialog.component';
import { CreateVendorDetailsComponent } from './create-vendor-details/create-vendor-details.component';
import { CreateSectionMasterDialogComponent } from './create-section-master-dialog/create-section-master-dialog.component';
import { CreateStoreMasterDialogComponent } from './create-store-master-dialog/create-store-master-dialog.component';
import { CreateSkuMasterDialogComponent } from './create-sku-master-dialog/create-sku-master-dialog.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { CreateProfitCostCenterComponent } from './create-profit-cost-center/create-profit-cost-center.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { OpeningBalanceComponent } from './opening-balance/opening-balance/opening-balance.component';
import { CreateRequisitionMasterDialogComponent } from './purches-module/requisition/create-requisition-master-dialog/create-requisition-master-dialog.component';
import { CommonProductComponent } from './purches-module/common-product/common-product.component';
import { CreateQuotationMasterDialogComponent } from './purches-module/request-for-quotation/create-quotation-master-dialog/create-quotation-master-dialog.component';
import { CreateQuotationReceiveComponentComponent } from './purches-module/quotation-receive/create-quotation-receive-component/create-quotation-receive-component.component';
import { CommonQuotationComponent } from './purches-module/common-quotation/common-quotation.component';
import { QuotationComparisionDialogComponent } from './purches-module/quotation-comparisions/quotation-comparision-dialog/quotation-comparision-dialog.component';
// import { DynamicTableComponentComponent } from './purches-module/dynamic-table-component/dynamic-table-component.component';
import { PurchaseOrderDialogComponent } from './purches-module/purchase-order/purchase-order-dialog/purchase-order-dialog.component';
import { CreateQualityCheckDialogComponent } from './purches-module/quality-check/create-quality-check-dialog/create-quality-check-dialog.component';
import { GrnDialogComponent } from './purches-module/grn/grn-dialog/grn-dialog.component';
import { BulkVoucherPostingComponent } from './bulk-voucher-posting/bulk-voucher-posting.component';
// import { InventoryComponent } from './inventory/inventory.component';
// import { SalesOrderDialogComponent } from './sales-module/sales-order/sales-order-dialog/sales-order-dialog.component';
import { GsnDialogComponent } from './sales-module/gsn/gsn-dialog/gsn-dialog.component';
import { BudgetViewComponent } from './budget-view/budget-view.component';
import { CreateBudgetViewDialogComponent } from './create-budget-view-dialog/create-budget-view-dialog.component';
import { LoaderComponent } from './utility/loader/loader.component';
import { LoaderInterceptor } from './loader.interceptor';
import { ApprovalComponent } from './approval/approval.component';
import { ApprovalDialogComponent } from './approval-dialog/approval-dialog.component';
import { VoucherApprovalDialogComponent } from './voucher-approval-dialog/voucher-approval-dialog.component';
import { SalesOrderFileModalComponent } from './sales-module/sales-order/sales-order-file-modal/sales-order-file-modal.component';
import { PurchaseOrderFileModalComponent } from './purches-module/purchase-order/purchase-order-file-modal/purchase-order-file-modal.component';
import { SupplysyncLayoutComponent } from './layouts/supplysync-layout/supplysync-layout.component';
import { StocksphereLayoutComponent } from './layouts/stocksphere-layout/stocksphere-layout.component';
import { StocksphereModule } from "./components/stocksphere/stocksphere.module";
import { SupplysyncModule } from './components/supplysync/supplysync.module';
import { CreateProductEditDialogComponent } from './create-product-edit-dialog/create-product-edit-dialog.component';
import { CreateProductViewDialogComponent } from './create-product-view-dialog/create-product-view-dialog.component';
import { LedgerBookDialogComponent } from './ledger-book-dialog/ledger-book-dialog.component';
import { CreateContactPersonMasterDialogComponent } from './create-contact-person-master-dialog/create-contact-person-master-dialog.component';
import { AuditDialogComponent } from './audit-dialog/audit-dialog.component';
import { BudgetDialogComponent } from './budget-dialog/budget-dialog.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PricePolicyDialogComponent } from './price-policy-dialog/price-policy-dialog.component';
import { CategoryItemDialogComponent } from './category-item-dialog/category-item-dialog.component';

// import { CommonFilterComponent } from './common-filter/common-filter.component';
// import { PermissionComponent } from './components/acl/permission/permission.component';
import { DocumentComponent } from './document/document.component';
import { CreateDocumentDialogComponent } from './create-document-dialog/create-document-dialog.component';
import { GrnFileModalComponent } from './purches-module/grn/grn-file-modal/grn-file-modal.component';
import { QualityCheckFileModalComponent } from './purches-module/quality-check/quality-check-file-modal/quality-check-file-modal.component';
import { ProfitCostCategoryDialogComponent } from './profit-cost-category-dialog/profit-cost-category-dialog.component';
import { CreateCategoryBudgetDialogComponent } from './create-category-budget-dialog/create-category-budget-dialog.component';
import { PurchaseOrderViewDialogComponent } from './purchase-order-view-dialog/purchase-order-view-dialog.component';
import { PurchaseOrderArchiveComponent } from './purchase-order-archive/purchase-order-archive.component';
import { VoucherFileModalComponent } from './voucher-file-modal/voucher-file-modal.component';
import { CategoryBudgetViewComponent } from './category-budget-view/category-budget-view.component';
import { BudgetLedgerViewComponent } from './budget-ledger-view/budget-ledger-view.component';
import { ProfitcostCommentDialogComponent } from './profitcost-comment-dialog/profitcost-comment-dialog.component';
import { CreateCompanyUnitMasterDialogComponent } from './create-company-unit-master-dialog/create-company-unit-master-dialog.component';
import { CreateCompanyServiceMasterDialogComponent } from './create-company-service-master-dialog/create-company-service-master-dialog.component';
import { CreateCompanyItemMasterDialogComponent } from './create-company-item-master-dialog/create-company-item-master-dialog.component';
import { PurchaseOrderManualDialogComponent } from './purchase-order-manual-dialog/purchase-order-manual-dialog.component';
import { PeoplepulseLayoutComponent } from './layouts/peoplepulse-layout/peoplepulse-layout.component';
import { PeoplepulseModule } from './components/peoplepulse/peoplepulse.module';

import { CreateStateMasterDialogComponent } from './components/peoplepulse/components/create-state-master-dialog/create-state-master-dialog.component';
import { LocationMasterDialogComponent } from './components/peoplepulse/components/location-master-dialog/location-master-dialog.component';
import { CreateEarningDialogComponent } from './components/peoplepulse/components/create-earning-dialog/create-earning-dialog.component';
import { CreateDeductionDialogComponent } from './components/peoplepulse/components/create-deduction-dialog/create-deduction-dialog.component';
import { CreateCategoryDialogComponent } from './components/peoplepulse/components/create-category-dialog/create-category-dialog.component';
import { CreateDesignationDialogComponent } from './components/peoplepulse/components/create-designation-dialog/create-designation-dialog.component';
import { CreateCategoryMappingDialogComponent } from './components/peoplepulse/components/create-category-mapping-dialog/create-category-mapping-dialog.component';
import { CreatePaplDesignationDialogComponent } from './components/peoplepulse/components/create-papl-designation-dialog/create-papl-designation-dialog.component';
import { CreateEsiPfMappingDialogComponent } from './components/peoplepulse/components/create-esi-pf-mapping-dialog/create-esi-pf-mapping-dialog.component';
import { CreateSalaryRangeDialogComponent } from './components/peoplepulse/components/create-salary-range-dialog/create-salary-range-dialog.component';
import { CreateEnrollmentDialogComponent } from './components/peoplepulse/components/create-enrollment-dialog/create-enrollment-dialog.component';
import { CreateDailyAttendanceDialogComponent } from './components/peoplepulse/components/create-daily-attendance-dialog/create-daily-attendance-dialog.component';
import { CreatePermanentEnrollmentDialogComponent } from './components/peoplepulse/components/create-permanent-enrollment-dialog/create-permanent-enrollment-dialog.component';
import { CreatePostingHistoryDialogComponent } from './components/peoplepulse/components/create-posting-history-dialog/create-posting-history-dialog.component';
import { CreateProfitCostCenterManpowerDialogComponent } from './components/peoplepulse/components/create-profit-cost-center-manpower-dialog/create-profit-cost-center-manpower-dialog.component';
import { CreateFirstPostingDialogComponent } from './components/peoplepulse/components/create-first-posting-dialog/create-first-posting-dialog.component';
import { CreateSalaryUpdateEffectiveDateDialogComponent } from './components/peoplepulse/components/create-salary-update-effective-date-dialog/create-salary-update-effective-date-dialog.component';
import { CreateSlabMasterDialogComponent } from './components/peoplepulse/components/create-slab-master-dialog/create-slab-master-dialog.component';
import { CreateGradeMasterDialogComponent } from './components/peoplepulse/components/create-grade-master-dialog/create-grade-master-dialog.component';
import { CreateEmployeeGradeDialogComponent } from './components/peoplepulse/components/create-employee-grade-dialog/create-employee-grade-dialog.component';
import { CreateSalaryCalculationFormulaDialogComponent } from './components/peoplepulse/components/create-salary-calculation-formula-dialog/create-salary-calculation-formula-dialog.component';
import { CreateSalaryFormulaDialogComponent } from './components/peoplepulse/components/create-salary-formula-dialog/create-salary-formula-dialog.component';
import { CreateAttendanceFormulaDialogComponent } from './components/peoplepulse/components/create-attendance-formula-dialog/create-attendance-formula-dialog.component';
import { CreateAttendanceCalculationDialogComponent } from './components/peoplepulse/components/create-attendance-calculation-dialog/create-attendance-calculation-dialog.component';
import { CreateMastersettingDialogComponent } from './components/peoplepulse/components/create-mastersetting-dialog/create-mastersetting-dialog.component';
import { CreateEmployeedataimportDialogComponent } from './components/peoplepulse/components/create-employeedataimport-dialog/create-employeedataimport-dialog.component';
import { CreateLeaveTypeDialogComponent } from './components/peoplepulse/components/create-leave-type-dialog/create-leave-type-dialog.component';
import { CreateLeavepolicyDialogComponent } from './components/peoplepulse/components/create-leavepolicy-dialog/create-leavepolicy-dialog.component';
import { CreateLeaverequestDialogComponent } from './components/peoplepulse/components/create-leaverequest-dialog/create-leaverequest-dialog.component';
import { CreateCalculationMasterDialogComponent } from './components/peoplepulse/components/create-calculation-master-dialog/create-calculation-master-dialog.component';
import { CreatePromotionDialogComponent } from './components/peoplepulse/components/create-promotion-dialog/create-promotion-dialog.component';
import { CreatePostingdataDialogComponent } from './components/peoplepulse/components/create-postingdata-dialog/create-postingdata-dialog.component';
import { SalarySlipComponent } from './components/peoplepulse/components/salary-slip/salary-slip.component';
import { CreateProfitcostFormulaMappingDialogComponent } from './components/peoplepulse/components/create-profitcost-formula-mapping-dialog/create-profitcost-formula-mapping-dialog.component';
import { CreateEmployeeFormulaMappingDialogComponent } from './components/peoplepulse/components/create-employee-formula-mapping-dialog/create-employee-formula-mapping-dialog.component';

import { CreateFixedAssetsTemplateComponent } from './create-fixed-assets-template/create-fixed-assets-template.component';
import { CreateCompanyActCategoryComponent } from './create-company-act-category/create-company-act-category.component';
import { CreateItActCategoryComponent } from './create-it-act-category/create-it-act-category.component';
import { CreateDepreciationMethodComponent } from './create-depreciation-method/create-depreciation-method.component';
import { GsnFileComponent } from './sales-module/gsn/gsn-file/gsn-file.component';
import { CarryForwardPreviewDialogComponent } from './carry-forward-preview-dialog/carry-forward-preview-dialog.component';
import { CommonCalculationMethodComponent } from './common-calculation-method/common-calculation-method.component';
import { RequisitionReportProfitCostViewComponent } from './requisition-report-profit-cost-view/requisition-report-profit-cost-view.component';
import { CreateItemSkuMappingDialogComponent } from './create-item-sku-mapping-dialog/create-item-sku-mapping-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
// import { ItemWiseReportComponent } from './item-wise-report/item-wise-report.component';
import { CreateLedgerTypeDialogComponent } from './create-ledger-type-dialog/create-ledger-type-dialog.component';
import { HsnGstEditComponent } from './hsn-gst-edit/hsn-gst-edit.component';
import { LedgerPathSetupDialogComponent } from './ledger-path-setup-dialog/ledger-path-setup-dialog.component';
import { EmployeeMasterListComponent } from './employee-master-list/employee-master-list.component';
import { CreditNoteVoucherComponent } from './credit-note-voucher/credit-note-voucher.component';
import { DebitNoteVoucherComponent } from './debit-note-voucher/debit-note-voucher.component';
import { SalesVoucherComponent } from './sales-voucher/sales-voucher.component';
import { PurchaseVoucherComponent } from './purchase-voucher/purchase-voucher.component';
import { UiModule } from './shared/ui/ui.module';
// import { CategoryBudgetComponent } from './category-budget/category-budget.component';
// import { ProfitcostCategoryMappingComponent } from './profitcost-category-mapping/profitcost-category-mapping.component';

export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${month < 10 ? '0' + month : month}/${year}`;
    }
    return super.format(date, displayFormat);
  }
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/yyyy',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'MM/yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule,
    ComponentsModule,
    SuperadminModule,
    RouterModule,
    AppRoutingModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    MatIconModule,
    MatTableModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatGridListModule,
    StocksphereModule,
    SupplysyncModule,
    PeoplepulseModule,
    CreateEnrollmentDialogComponent,
    MatTooltipModule,
    MatSnackBarModule,
    UiModule,
  ],

  declarations: [
    AppComponent,
    AdminLayoutComponent,
    CreateStatementDialogComponent,
    CreateGroupDialogComponent,
    CreateLedgerDialogComponent,
    CreateVoucherDialogComponent,
    CreateVoucherPostingDialogComponent,
    CreateBranchDialogComponent,
    ImportStatementViewComponent,
    LoginComponent,
    FileShowModalComponent,
    SuperadminLayoutComponent,
    UserRegistrationComponent,
    CreateVoucherPostingViewComponent,
    CreateVoucherPostingPreviewComponent,
    ApprovalPathMasterComponent,
    ApprovalPathMappingComponent,
    NotfoundComponent,
    CreateCategoryMasterComponent,
    CreateItemMasterComponent,
    CreateUnitMasterComponent,
    CreateGstMasterComponent,
    CreatServiceMasterDialogComponent,
    CreateProductEditDialogComponent,
    CreateProductViewDialogComponent,
    CreateInvoicePaymentDialogComponent,
    CreateSectionMasterDialogComponent,
    CreateSkuMasterDialogComponent,
    CreateProfitCostCenterComponent,
    ConfirmationComponent,
    OpeningBalanceComponent,
    // DynamicTableComponentComponent,
    // user acl
    LoginDashboardComponent,
    DashboardComponent,
    UserListComponent,
    //     // PermissionComponent  
    BulkVoucherPostingComponent,
    LoaderComponent,
    ApprovalDialogComponent,
    VoucherApprovalDialogComponent,
    // CommonFilterComponent,
    BudgetViewComponent,
    CreateBudgetViewDialogComponent,
    SupplysyncLayoutComponent,
    StocksphereLayoutComponent,
    SalesOrderFileModalComponent,
    PurchaseOrderFileModalComponent,
    LedgerBookDialogComponent,
    CreateContactPersonMasterDialogComponent,
    DocumentComponent,
    CreateDocumentDialogComponent,
    AuditDialogComponent,
    BudgetDialogComponent,
    PricePolicyDialogComponent,
    CategoryItemDialogComponent,
    GrnFileModalComponent,
    QualityCheckFileModalComponent,
    ProfitCostCategoryDialogComponent,
    CreateCategoryBudgetDialogComponent,
    PurchaseOrderViewDialogComponent,
    PurchaseOrderArchiveComponent,
    VoucherFileModalComponent,
    CategoryBudgetViewComponent,
    BudgetLedgerViewComponent,
    ProfitcostCommentDialogComponent,
    CreateCompanyUnitMasterDialogComponent,
    CreateCompanyServiceMasterDialogComponent,
    CreateCompanyItemMasterDialogComponent,
    PurchaseOrderManualDialogComponent,
    PeoplepulseLayoutComponent,
    CreateStateMasterDialogComponent,
    LocationMasterDialogComponent,
    CreateEarningDialogComponent,
    CreateDeductionDialogComponent,
    CreateCategoryDialogComponent,
    CreateDesignationDialogComponent,
    CreateCategoryMappingDialogComponent,
    CreatePaplDesignationDialogComponent,
    CreateEsiPfMappingDialogComponent,
    CreateSalaryRangeDialogComponent,
    CreateDailyAttendanceDialogComponent,
    CreatePermanentEnrollmentDialogComponent,
    CreatePostingHistoryDialogComponent,
    CreateProfitCostCenterManpowerDialogComponent,
    CreateEmployeedataimportDialogComponent,
    CreateLeaveTypeDialogComponent,
    CreateLeavepolicyDialogComponent,
    CreateLeaverequestDialogComponent,
    CreateCalculationMasterDialogComponent,
    CreatePromotionDialogComponent,
    CreateFirstPostingDialogComponent,
    CreateSalaryUpdateEffectiveDateDialogComponent,
    CreateSlabMasterDialogComponent,
    CreateGradeMasterDialogComponent,
    CreateEmployeeGradeDialogComponent,
    CreateSalaryCalculationFormulaDialogComponent,
    CreateSalaryFormulaDialogComponent,
    CreateAttendanceFormulaDialogComponent,
    CreateAttendanceCalculationDialogComponent,
    CreateMastersettingDialogComponent,
    CreatePostingdataDialogComponent,
    SalarySlipComponent,
    CreateProfitcostFormulaMappingDialogComponent,
    CreateEmployeeFormulaMappingDialogComponent,
    
    CreateFixedAssetsTemplateComponent,
    CreateCompanyActCategoryComponent,
    CreateItActCategoryComponent,
    CreateDepreciationMethodComponent,
    GsnFileComponent,
    CarryForwardPreviewDialogComponent,
    CommonCalculationMethodComponent,
    RequisitionReportProfitCostViewComponent,
    // ItemWiseReportComponent,
    CreateItemSkuMappingDialogComponent,
    CreateLedgerTypeDialogComponent,
    HsnGstEditComponent,
    // CategoryBudgetComponent,
    // ProfitcostCategoryMappingComponent
    LedgerPathSetupDialogComponent,
    EmployeeMasterListComponent,
    CreditNoteVoucherComponent,
    DebitNoteVoucherComponent,
    SalesVoucherComponent,
    PurchaseVoucherComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
    { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LogInterceptor,
      multi: true
    },
  {
    provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
    useValue: {
      showDelay: 300,
      hideDelay: 100,
      touchendHideDelay: 1000,
      position: 'above'
    }
  }
],
  bootstrap: [AppComponent]
})
export class AppModule { }
